//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

const DEFAULT_DELAY_SHOW = 0;
const DEFAULT_DELAY_HIDE = null;

/**
 * Delay in ms once a trigger event is fired before a tippy shows or hides.
 *
 * @property delay.showDelay The delay in ms before tippy shows
 * @property delay.hideDelay The delay in ms before tippy hides
 *
 * See Popper docs for more info: https://atomiks.github.io/tippyjs/v6/all-props/#delay
 */
export interface IPopoverDelay {
  showDelay?: number;
  hideDelay?: number;
}

/**
 * Tippy expects a [showDelay, hideDelay] tuple as its delay prop, so this helper defaults
 * the delay values with our standardized delays and converts the interface to that structure.
 */
export const popoverDelayToTippyDelay = ({
  showDelay = DEFAULT_DELAY_SHOW,
  hideDelay,
}: IPopoverDelay): [number, number | null] => [
  showDelay,
  hideDelay ?? DEFAULT_DELAY_HIDE,
];
